// react components
import React, {
    useEffect,
    useState,
} from 'react'

// data
import {
    contentTypeModelTypeSite,
} from 'data'

// pages
import {
    TableHeaderColumn825,
} from 'pages'

// serializers
import {
    ContentTypeFieldTypes,
    ContentTypeSettingsTypes,
} from 'serializers/site'

// services
import {
    getFieldTitleSite,
} from 'services'

// props
type TableHeader825Props = {
    columns: string[]
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    count: number | undefined
    filterValues: any
    inModal?: boolean
    isLoading?: boolean
    profile: any | undefined
    setExportColumns: React.Dispatch<React.SetStateAction<{
        columnName: string
        columnTitle: string
        fieldOptions: ContentTypeFieldTypes | undefined
    }[]>> | undefined
    setFilter?: (e: any, f?: any) => void
    subContentTypeId?: number
}

// main
export const TableHeader825: React.FC<TableHeader825Props> = React.memo(({
    columns,
    contentType,
    contentTypeSettings,
    count,
    filterValues,
    inModal,
    isLoading,
    profile,
    setExportColumns,
    setFilter,
    subContentTypeId,
}) => {

    const [newColumns, setNewColumns] = useState<{
        columnName: string
        columnTitle: string
        fieldOptions: ContentTypeFieldTypes | undefined
    }[]>([])

    useEffect(() => {
        const extraAutoColumns: {
            columnName: string
            columnTitle: string
            fieldOptions: ContentTypeFieldTypes | undefined
        }[] = []
        columns?.map(column => {
            const getFieldTitleResult = getFieldTitleSite({
                column: column,
                contentType: contentType,
                contentTypeSettings: contentTypeSettings,
                profile: profile,
                subContentType: subContentTypeId,
            })
            extraAutoColumns.push({
                columnName: column,
                columnTitle: getFieldTitleResult.columnTitle,
                fieldOptions: getFieldTitleResult.fieldOptions,
            })
        })
        if (setExportColumns) setExportColumns(extraAutoColumns)
        setNewColumns(extraAutoColumns)
    }, [
        columns,
        contentType,
    ])

    if (!contentType || isLoading) return null

    return (
        <tr className='table-header'>
            <th className='th-column field-action'>
                <div className='th-div'>
                    {count !== undefined ? `(${count})` : '()'}
                </div>
            </th>
            {newColumns.map(val => (
                <TableHeaderColumn825
                    key={val.columnName}
                    column={val.columnName}
                    contentType={contentType}
                    fieldOptions={val.fieldOptions}
                    filterValues={filterValues}
                    inModal={inModal}
                    setFilter={setFilter}
                    title={val.columnTitle}
                />
            ))}
        </tr>
    )
})
